/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Refresh_DataInputs */

const fr_map_refresh_data = /** @type {(inputs: Map_Refresh_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rafraichir les données`)
};

const en_map_refresh_data = /** @type {(inputs: Map_Refresh_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh data`)
};

/**
* | output |
* | --- |
* | "Refresh data" |
*
* @param {Map_Refresh_DataInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const map_refresh_data = /** @type {((inputs?: Map_Refresh_DataInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Refresh_DataInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_map_refresh_data(inputs)
	return en_map_refresh_data(inputs)
});